<template>
  <div id="app">
    <div id="interaction-helper"></div>
    <transition mode="out-in" @before-enter="beforeEnter" @enter="enter" @before-leave="beforeLeave" @leave="leave">
      <router-view />
    </transition>
  </div>
</template>

<script>
import gsap from 'gsap'

export default {
  name: 'App',
  mounted () {
    window.addEventListener('resize', this.appHeight)
    this.appHeight()
    setTimeout(() => {
      this.appHeight()
    }, 5000)

    this.$nextTick(() => {
      this.appHeight()
      if (this.$tools.expoMode()) document.body.classList.add('standalone')
    })

    if (this.$tools.expoMode()) {
      document.addEventListener('click', () => {
        // this.expoMode()
      }, { once: true })
    }
  },
  data () {
    return {
      twig: {
        ease: 'power4.inOut',
        duration: 1
      }
    }
  },
  methods: {
    appHeight () {
      const doc = document.documentElement
      doc.style.setProperty('--app-height', `${window.innerHeight}px`)
    },
    beforeEnter (el) {
      console.log('before enter')
      el.style.transform = 'translateY(100vh)'
      el.querySelector('.mask').style.oppacity = 1
      el.querySelector('.mask').style.display = 'block'
    },
    enter (el) {
      console.log('enter')

      const tl = gsap.timeline({ lazy: false })

      tl.to(el, {
        duration: this.twig.duration,
        opacity: 1,
        translateY: '0vh',
        ease: this.twig.ease
      })
      tl.fromTo(el.querySelector('.mask'),
        {
          opacity: 1
        },
        {
          duration: this.twig.duration * 1.2,
          opacity: 0,
          ease: this.twig.ease,
          onComplete: () => {
            el.querySelector('.mask').style.display = 'none'
          }
        },
        `-=${this.twig.duration / 2}`
      )
    },
    beforeLeave (el) {
      console.log('before leave')
      el.style.transform = 'translateY(0vh)'
    },
    leave (el, done) {
      console.log('leave')

      gsap.to(el, {
        duration: this.twig.duration,
        opacity: 1,
        translateY: '-100vh',
        ease: this.twig.ease,
        onComplete: done,
        lazy: false
      })
    },
    expoMode () {
      if (document.body.requestFullscreen) {
        document.body.requestFullscreen()
      } else if (document.body.webkitRequestFullscreen) { /* Safari */
        document.body.webkitRequestFullscreen()
      } else if (document.body.msRequestFullscreen) { /* IE11 */
        document.body.msRequestFullscreen()
      }

      // disable right click
      document.addEventListener('contextmenu', event => event.preventDefault())
    }
  }
}
</script>

<style lang="scss">
@import "./styles/reset.css";

#app{
  height: 100%;
  width: 100%;
  background-color: color(primary);
  transform: translate3d(0,0,0);
}

#interaction-helper{
  display: none;
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  z-index: 1000;
}

</style>
